import styled from 'styled-components';

export const LinkWrapper = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;
